export function CheckIfImageExists(url, callback = function () {}) {
    const img = new Image();
    img.src = url;

    if (img.complete) {
        callback(true);
    } else {
        img.onload = () => {
            if (img.naturalHeight > 0 && img.naturalWidth > 0) {
                callback(true);
            } else {
                callback(false);
            }
        };

        img.onerror = () => {
            callback(false);
        };
    }
}
